import { useEffect } from "react";
import { useRouteError } from "react-router";

import { GlobalError } from "@/common-ui";
import { useLogger } from "@/sdk/logging/LoggerProvider";
import { emitWorkspaceShellCrash } from "@/shared-utils/workspaceShellCrashMetric";

// A plain reload, unlike Home's sign-in error screen: persisted stores (e.g. pending callbacks) must survive it.
function reload() {
    globalThis.location.reload();
}

/** Last-resort `errorElement` for render errors no deeper boundary caught, so the page isn't left blank. */
export function RouteErrorFallback() {
    const error = useRouteError();
    const logger = useLogger({ module: "RouteErrorFallback", supportTeam: "platform" });

    useEffect(() => {
        logger.fatal({ error }, "Root error boundary caught an error");
        emitWorkspaceShellCrash("root");
    }, [logger, error]);

    return (
        <GlobalError
            msg="Something went wrong and Expert Workspace stopped. Refresh to start it again."
            onRefresh={reload}
        />
    );
}
